module.exports = __webpack_public_path__ + "img/normal.05890d06.svg";